<form
  *ngIf="!!form"
  [formGroup]="form"
  style="position: relative"
>
  <span
    *ngIf="clearable && hasValue"
    class="clear-icon"
    (click)="clearField()"
  >Clear</span>

  <app-input-wrapper
    [title]="title"
    [formControlNameString]="formControlNameString"
  >
    <input
      matInput
      appFormControl
      [matDatepicker]="datepicker"
      [min]="minDate"
      [max]="maxDate"
      [formControlName]="formControlNameString"
      (dateChange)="emitValue($event.value)"
    >
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>

  </app-input-wrapper>
</form>
